import { cloneDeep } from 'lodash';
import { getProcessEnvUrl } from './getUrl';
import { LOGIN } from '../Router/routes';
import { ValidationError } from '.';
import axios, { AxiosRequestHeaders } from 'axios';

function getTokenFromSessionStorage() {
  return sessionStorage.getItem('token');
}

const axiosInstance = axios.create({
  baseURL: getProcessEnvUrl('WEB_API'),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  } as AxiosRequestHeaders,
});

// This is a request interceptor that will run before every request.
// It will add the Authorization header with the token from sessionStorage.
axiosInstance.interceptors.request.use(function getInternalAxiosRequestConfig(
  config,
) {
  // Already has Authorization header
  if (config.headers.Authorization) {
    return config;
  }

  const token = getTokenFromSessionStorage();
  // No token in sessionStorage
  if (!token) {
    return config;
  }

  const newConfig = cloneDeep(config);
  newConfig.headers.Authorization = `Basic ${token}`;
  return newConfig;
});

axiosInstance.interceptors.response.use(
  function getInternalAxiosResponseConfig(response) {
    return response;
  },
  function onRejected(error) {
    if (error.response.status === 401) {
      // Wrong credentials from login endpoint return 401, returns error as normal error
      if (error.response.request.responseURL.includes('/token/basic')) {
        return Promise.reject(error);
      }

      // User clicked logout button despite the session is expired. Error about session expired is not needed because user expects login redirection
      if (error.response.config.url === '/token/invalidate') {
        sessionStorage.removeItem('token');
        window.location.assign(LOGIN);
        return Promise.resolve();
      }

      sessionStorage.removeItem('token');
      window.location.assign(`${LOGIN}?sessionExpired=true`);
    }

    if (error.response.status === 400 && error.response.data.errors) {
      const validationError = new ValidationError(error.response.data.errors);
      return Promise.reject(validationError);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
